/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShiftChangeProposals} from '../api'

 export const useQueryGetShiftChangeProposals = createReactQueryHook('getShiftChangeProposals', getShiftChangeProposals)
